var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
      'position': 'relative',
      'width': (_vm.size + "px"),
      'padding-bottom': '170%',
      'border-color': _vm.color,
      'border-radius': ((_vm.size / 2) + "px"),
      'border-width': ((Math.ceil(_vm.size / 20)) + "px")
    })},[_c('span',{style:({
        'position': 'absolute',
        'width': ((Math.ceil(_vm.size / 10)) + "px"),
        'padding-bottom': '40%',
        'top': '20%',
        'left': '50%',
        'margin-left': ("-" + (Math.ceil(_vm.size / 10) / 2) + "px"),
        'border-radius': ((Math.ceil(_vm.size / 10) / 2) + "px"),
        'background': _vm.color
      })})])])}
var staticRenderFns = []

export { render, staticRenderFns }